.btn-information{margin:10px 0 0 10px;padding:3px 9px}
/*# sourceMappingURL=network-table.component-D2BJMSGA.css.map */
